import { createAction } from '../../utils/redux/createAction';
import { consts as editPaymentAmount } from '../healthboard/requests/edit-payment-req';

const actionsScope = 'dashboard/edit-payment-amount-modal';

export const DASHBOARD_EDIT_PAYMEN_AMOUNT = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const dashboardEditPaymentAmountActions = {
  open: createAction(DASHBOARD_EDIT_PAYMEN_AMOUNT.OPEN),
  close: createAction(DASHBOARD_EDIT_PAYMEN_AMOUNT.CLOSE),
};

const initialState = {
  opened: false,
  appointment: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case DASHBOARD_EDIT_PAYMEN_AMOUNT.OPEN: {
      return {
        ...state,
        opened: true,
        appointment: payload,
      };
    }

    case editPaymentAmount.SUCCEED:
    case DASHBOARD_EDIT_PAYMEN_AMOUNT.CLOSE: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/dashboard/edit-payment-amount-modal.js